import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";

import myImage from "./img/timer_icon.svg";

import "./style.scss";

const Timer = inject("mainStore")(
    observer(({ mainStore }) => {
        const isStart = mainStore.getMainStore("isStart");
        const [over, setOver] = useState(false);
        const [[m, s, mil], setTime] = useState([5, 0, 0]);
        const [widthShadovTimer, setWidthShadovTimer] = useState(0);
        const [widthShadov, setWidthShadov] = useState(0);

        const tick = () => {
            if (over || isStart) return;
            setWidthShadovTimer((prev) => prev + 0.01);
            setWidthShadov((widthShadovTimer / 3) * 1);
            if (m === 0 && s === 0 && mil === 0) {
                setOver(true);
            } else if (s === 0 && mil === 0) {
                setTime([m - 1, 59, 99]);
            } else if (mil == 0) {
                setTime([m, s - 1, 99]);
            } else {
                setTime([m, s, mil - 1]);
            }
        };

        useEffect(() => {
            const timerID = setInterval(() => tick(), 10);
            return () => clearInterval(timerID);
        });

        return (
            <>
                <div className="timer" id="timer">
                    <div className={`timer_shadov`} style={{ width: `${widthShadov}%` }}></div>
                    <img src={myImage} />У вас осталось{" "}
                    <span>
                        <div>{`${m.toString().padStart(2, "0")}`}</div>:<div>{`${s.toString().padStart(2, "0")}`}</div>:<div>{`${mil.toString().padStart(2, "0")}`}</div>
                    </span>
                </div>

                <div className="timer_mobile">
                    <div className={`timer_shadov`} style={{ width: `${widthShadov}%` }}></div>
                    <img src={myImage} />У вас осталось{" "}
                    <span>
                        <div>{`${m.toString().padStart(2, "0")}`}</div>:<div>{`${s.toString().padStart(2, "0")}`}</div>:<div>{`${mil.toString().padStart(2, "0")}`}</div>
                    </span>
                </div>
            </>
        );
    }),
);

export default Timer;
